import { type CalendarDay } from '../types/calendar.type'

/**
 * 月を MM 形式の文字列にする
 */
export const pad = (month: number) => {
  if (month < 10) {
    return `0${month}`
  }
  return `${month}`
}

/**
 * その月の日リストを配列で得る
 * またカレンダーを形成するため、日曜日から始まり、日が存在しない場合は空文字で埋める
 * @param year
 * @param month
 * @returns
 */
export function getCalendarDays(year: number, month: number) {
  const days: CalendarDay[] = []

  const lastDay = new Date(year, month, 0).getDate()
  let day = 1

  while (day <= lastDay) {
    for (let i = 0; i < 7; i++) {
      const dayOfWeek = (new Date(year, month - 1, day)).getDay()
      if (i !== dayOfWeek || day > lastDay) {
        days.push('')
      } else {
        days.push(day as CalendarDay)
        day++
      }
    }
  }

  return days
}

/**
 * 前月 もしくは 前年の12月 を得る
 * @param year
 * @param month
 * @returns
 */
export function getPreviousMonth(year: number, month: number) {
  if (month === 1) {
    return { year: year - 1, month: 12}
  }
  return { year: year, month: month - 1 }
}

/**
 * 翌月 もしくは 翌年の1月 を得る
 * @param year
 * @param month
 * @returns
 */
export function getNextMonth(year: number, month: number) {
  if (month === 12) {
    return { year: year + 1, month: 1}
  }
  return { year: year, month: month + 1 }
}

/**
 * その月の開始と終了の日時を得る
 * @param year
 * @param month
 */
export function getEdgeDates(year: number, month: number) {
  const start = new Date(`${year}-${pad(month)}-01T00:00:00.000+09:00`)

  const lastDay = new Date(year, month, 0).getDate()
  const end = new Date(`${year}-${pad(month)}-${lastDay}T23:59:59.999+09:00`)

  return [start, end]
}

/**
 * カレンダーの前月を表示状態を得る
 * @param year
 * @param month
 * @param baseDate
 * @returns
 */
export function isPrevMonthVisible(year: number, month: number, baseDate: Date) {
  const baseYear = baseDate.getFullYear()
  const baseMonth = baseDate.getMonth() + 1
  if (year < baseYear || (year === baseYear && month <= baseMonth)) {
    return false
  }
  return true
}

/**
 * カレンダーの次月を表示状態を得る
 * @param year
 * @param month
 * @param baseDate
 * @returns
 */
export function isNextMonthVisible(year: number, month: number, baseDate: Date) {
  const baseYear = baseDate.getFullYear()
  const baseMonth = baseDate.getMonth() + 1
  if (year > baseYear || (year === baseYear && month >= baseMonth)) {
    return false
  }
  return true
}
